import React, { ReactNode, useState } from 'react'
import DefaultHeading from '../../components/heading/DefaultHeading'
import './manageSSO.css';
import { Tab, Tabs, styled } from '@mui/material';
import SSOHome from '../../components/manageSSO/SSOHome';
import SSOSaml from '../../components/manageSSO/SSOSaml';
import SSOOuth2 from '../../components/manageSSO/SSOOuth2';
import SSOAPI from '../../components/manageSSO/SSOAPI';


interface StyledTabProps {
  label: string;
  value: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(17),
  marginRight: theme.spacing(1),
  background:"#efeded",
  borderRadius:'5px',
  color: 'black',
  '&.Mui-selected': {
    color: '#fff',
    background:"var(--dashboard-secondary-color)",
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)',
  },
}));




function ManageSSO() {

  const [selectedTab , setSelectedTab] = useState('home');


  const handleChange = (e:any,val:string)=>{
    setSelectedTab(val);
  }

  
  const renderTabContent = (tabValue:string):ReactNode=>{
    let val = tabValue.toLowerCase();
    switch(val){
      case 'home' : return <SSOHome/>;
      case 'saml' : return <SSOSaml/>;
      case 'oauth2' : return <SSOOuth2/>;
      case 'api' : return <SSOAPI/>;
      default : return <></>
    }
  }


  return (
    <div className='managessoWrapper'>
      <DefaultHeading heading='MANAGE SSO' showDefaultBackButton/>

      <div className="manageSSO-content">
        <div className="tabs-container">
          <Tabs value={selectedTab} onChange={handleChange} centered indicatorColor={'primary'}>
            <StyledTab label="HOME" value={"home"} />
            <StyledTab label="SAML" value={"saml"} />
            <StyledTab label="OAUTH2" value={"oauth2"} />
            <StyledTab label="API" value={"api"} />
          </Tabs>
        </div>
        <div className="tab-content">
          {renderTabContent(selectedTab)}
        </div>
      </div>
    </div>
  )
}

export default ManageSSO